import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text3, Text4 } from '../../../styles';
import { Alert, Button } from 'antd';

const PricingConsentModal = (props) => {
    return (
        <EaseModal
            width={850}
            title={false}
            visible={props.visible}
            closable={false}
            centered
            hideFooter
        >
            {props.current_user.service_charges ? <>
                <Alert description={
                    <div>
                        <div className="font-weight-bold mb-2" style={{ fontSize: "17px" }}>Introducing WIRE</div>
                        <Text4>
                            A platform for instant refunds, payouts to third party vendors and suppliers. Use the dashboard to pay instantly from your virtual account.
                        </Text4>
                    </div>
                } />
                <div className="font-weight-bold mb-2 mt-4" style={{ fontSize: "17px" }}>Platform Charges</div>
                <div className="row no-gutters border">
                    <div className="col-3 p-2 border-right border-bottom" style={{ background: "rgba(0, 0, 0, 0.05)", fontWeight: "bold" }}><Text3>IMPS</Text3></div>
                    <div className="col-3 p-2 border-right border-bottom" style={{ background: "rgba(0, 0, 0, 0.05)", fontWeight: "bold" }}><Text3>NEFT</Text3></div>
                    <div className="col-3 p-2 border-right border-bottom" style={{ background: "rgba(0, 0, 0, 0.05)", fontWeight: "bold" }}><Text3>RTGS</Text3></div>
                    <div className="col-3 p-2 border-bottom" style={{ background: "rgba(0, 0, 0, 0.05)", fontWeight: "bold" }}><Text3>UPI</Text3></div>
                    <div className="col-3 p-2 border-right">
                        {
                            props?.current_user?.service_charges?.IMPS?.map((chrg, category_index) => {
                                const commision_chrg = props.current_user.is_easebuzz_merchant ? 0 : props.current_user.commission_charges['IMPS'][category_index]['charge'];
                                return (
                                    <Text4>{chrg.min_txn_amount || chrg.min_txn_amount == 0 ? "₹" + chrg.min_txn_amount : ""}{chrg.max_txn_amount ? " to ₹" + chrg.max_txn_amount + " => " : chrg.min_txn_amount ? " and above => " : ""}{chrg.charge_in_percent ? "% " : "₹ "} {chrg.charge + commision_chrg} <br /></Text4>
                                )
                            })
                        }
                    </div>
                    <div className="col-3 p-2 border-right">
                        {
                            props.current_user.service_charges.NEFT.map((chrg, category_index) => {
                                const commision_chrg = props.current_user.is_easebuzz_merchant ? 0 : props.current_user.commission_charges['NEFT'][category_index]['charge'];
                                return (
                                    <Text4>{chrg.min_txn_amount || chrg.min_txn_amount == 0 ? "₹" + chrg.min_txn_amount : ""}{chrg.max_txn_amount ? " to ₹" + chrg.max_txn_amount + " => " : chrg.min_txn_amount ? " and above => " : ""}{chrg.charge_in_percent ? "% " : "₹ "}{chrg.charge + commision_chrg} <br /></Text4>
                                )
                            })
                        }
                    </div>
                    <div className="col-3 p-2 border-right">
                        {
                            props.current_user.service_charges.RTGS.map((chrg, category_index) => {
                                const commision_chrg = props.current_user.is_easebuzz_merchant ? 0 : props.current_user.commission_charges['RTGS'][category_index]['charge'];
                                return (
                                    <Text4>{chrg.min_txn_amount || chrg.min_txn_amount == 0 ? "₹" + chrg.min_txn_amount : ""}{chrg.max_txn_amount ? " to ₹" + chrg.max_txn_amount + " => " : chrg.min_txn_amount ? " and above => " : ""}{chrg.charge_in_percent ? "% " : "₹ "}{chrg.charge + commision_chrg} <br /></Text4>
                                )
                            })
                        }
                    </div>
                    <div className="col-3 p-2">
                        {
                            props.current_user.service_charges?.UPI?.map((chrg, category_index) => {
                                const commision_chrg = props.current_user.is_easebuzz_merchant ? 0 : props.current_user.commission_charges['UPI'][category_index]['charge'];
                                return (
                                    <Text4>{chrg.min_txn_amount || chrg.min_txn_amount == 0 ? "₹" + chrg.min_txn_amount : ""}{chrg.max_txn_amount ? " to ₹" + chrg.max_txn_amount + " => " : chrg.min_txn_amount ? " and above => " : ""}{chrg.charge_in_percent ? "% " : "₹ "}{chrg.charge + commision_chrg} <br /></Text4>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="w-100 d-flex justify-content-between mt-4">
                    <Text4 style={{ fontStyle: 'italic' }}>* Excluding GST</Text4>
                    <Button type="primary" loading={props.isUpdatingConsent} onClick={props.onAccept}>Accept & Continue</Button>
                </div>
                {/* </div> */}
            </> : null}

        </EaseModal>


    )
};

PricingConsentModal.defaultProps = {
    user: {}
};

export { PricingConsentModal };